import { Radio } from '@mui/material'
import React from 'react'

export default function BegerzRadio(props) {
  return (
    <Radio sx={{ color:'white', '&.Mui-checked': {color: 'white'} }} {...props} />
  )
}